import React from 'react';
import SplitLayout from '../../common/layouts/splitLayout/SplitLayout';
import UserEligibilityForm from './UserEligibilityForm';
import EligibilitySummaryCard from './eligibilitySummaryCard/EligibilitySummaryCard';
import styles from './styles/segmentation-step.module.scss';

function SegmentationStep({
    values,
    summary,
    handlers,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit,
    onSubmit,
    onCancel,
    readOnly,
}) {
    return (
        <SplitLayout
            className={styles.splitRoot}
            contentClassName={styles.splitContent}
            sideClassName={styles.splitSide}
            side={<EligibilitySummaryCard data={summary} />}
        >
            <UserEligibilityForm
                values={values}
                loading={loading}
                disabledSave={disabledSave}
                submitText={submitText}
                confirmBeforeSubmit={confirmBeforeSubmit}
                onChange={handlers}
                onCancel={onCancel}
                onSubmit={onSubmit}
                readOnly={readOnly}
            />
        </SplitLayout>
    );
}

export default SegmentationStep;
